export const cxAlwaysInTouchConstants = {
    CX_GET_WINNERS_REQUEST:"CX_GET_WINNERS_REQUEST",
    CX_GET_WINNERS_COMPLETE:"CX_GET_WINNERS_COMPLETE",

    CX_GET_WINNERS_EXPORT_REQUEST:"CX_GET_WINNERS_EXPORT_REQUEST",
    CX_GET_WINNERS_EXPORT_COMPLETE:"CX_GET_WINNERS_EXPORT_COMPLETE",
    CX_CLEAR_WINNERS_EXPORT:"CX_CLEAR_WINNERS_EXPORT",

    CX_GET_WINNER_FILTER_OPTIONS_REQUEST:"CX_GET_WINNER_FILTER_OPTIONS_REQUEST",
    CX_GET_WINNER_FILTER_OPTIONS_COMPLETE:"CX_GET_WINNER_FILTER_OPTIONS_COMPLETE",

    CX_GET_JOB_ROLES_REQUEST:"CX_GET_JOB_ROLES_REQUEST",
    CX_GET_JOB_ROLES_COMPLETE:"CX_GET_JOB_ROLES_COMPLETE",

    CX_ADD_WINNERS_REQUEST:"CX_ADD_WINNERS_REQUEST",
    CX_ADD_WINNERS_COMPLETE:"CX_ADD_WINNERS_COMPLETE",
    CX_CLEAR_ADD_WINNERS_RESULT:"CX_CLEAR_ADD_WINNERS_RESULT",

    // The award is GBP 50, which the backend credits as 5000 points. The file and the screen both
    // carry pounds, so nothing here converts: reading this column as points is what underpaid a
    // winner by a factor of a hundred once already.
    CX_DEFAULT_REWARD_GBP:50,

    CX_APPLICATION_EQUIPE_ID:1,
}
